<form [formGroup]='passwordForm' fxLayout='column' fxLayoutAlign='start stretch'>

  <mat-form-field *ngIf="showCurrentPasswordField">
    <mat-label><adp-label labelKey="PasswordForm_CurrentPasswordField_Label"></adp-label></mat-label>
    <input matInput [type]='currentPasswordHidden ? "password" : "text"' formControlName='currentPassword' autocomplete='current-password' required>
    <button type='button' mat-icon-button matSuffix (click)='toggleCurrentPasswordVisibility()'
      [attr.aria-label]='resourceService.getViewLabel(currentPasswordHidden ? "PasswordForm_PasswordField_RevealPassword_Text" : "PasswordForm_PasswordField_HidePassword_Text")'
      [attr.aria-pressed]='currentPasswordHidden'>
      <mat-icon>{{currentPasswordHidden ? 'visibility' : 'visibility_off'}}</mat-icon>
    </button>
    <mat-error *ngIf='passwordForm.hasError("required", "currentPassword")'>
      <adp-label labelKey="PasswordForm_CurrentPasswordField_Required_Message"></adp-label>
    </mat-error>
  </mat-form-field>

  <mat-form-field>
    <mat-label><adp-label [labelKey]="passwordLabelSFKey"></adp-label></mat-label>
    <input matInput autofocus [type]='passwordHidden ? "password" : "text"' formControlName='password' autocomplete='new-password' required>
    <button type='button' mat-icon-button matSuffix (click)='togglePasswordVisibility()'
      [attr.aria-label]='resourceService.getViewLabel(passwordHidden ? "PasswordForm_PasswordField_RevealPassword_Text" : "PasswordForm_PasswordField_HidePassword_Text")'
      [attr.aria-pressed]='passwordHidden'>
      <mat-icon>{{passwordHidden ? 'visibility' : 'visibility_off'}}</mat-icon>
    </button>
    <mat-error *ngIf='passwordForm.hasError("password", "password")'>
      <adp-label [labelKey]="passwordForm.getError('password', 'password')"></adp-label>
    </mat-error>
  </mat-form-field>

  <mat-form-field class="mt-15">
    <mat-label><adp-label [labelKey]="confirmPasswordLabelSFKey"></adp-label></mat-label>
    <input matInput [type]='confirmPasswordHidden ? "password" : "text"' formControlName='confirmPassword' autocomplete='new-password' required>
    <button type='button' mat-icon-button matSuffix (click)='toggleConfirmPasswordVisibility()'
      [attr.aria-label]='resourceService.getViewLabel(confirmPasswordHidden ? "PasswordForm_PasswordField_RevealPassword_Text" : "PasswordForm_PasswordField_HidePassword_Text")'
      [attr.aria-pressed]='confirmPasswordHidden'>
      <mat-icon>{{confirmPasswordHidden ? 'visibility' : 'visibility_off'}}</mat-icon>
    </button>
    <mat-error *ngIf='passwordForm.hasError("matchField", "confirmPassword") && !passwordForm.hasError("required", "confirmPassword")'>
      <adp-label [labelKey]="passwordForm.getError('matchField', 'confirmPassword')"></adp-label>
    </mat-error>
    <mat-error *ngIf='passwordForm.hasError("required", "confirmPassword")'>
      <adp-label labelKey="PasswordForm_ConfirmPasswordField_Required_Message"></adp-label>
    </mat-error>
  </mat-form-field>

  <div fxLayout="row" class="gap-3 password-requirement-text mt-20">
    <div fxFlex="1 0 20px" fxLayout="column" class="gap-1">
      <ng-container *ngFor="let item of passwordRequirements$ | async; index as i; count as numElements">
        <ng-container *ngIf="i < numElements / 2">
          <ng-container *ngTemplateOutlet="passwordRequirement; context: {$implicit: item}"></ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div fxFlex="1 0 20px" fxLayout="column" class="gap-1">
      <ng-container *ngFor="let item of passwordRequirements$ | async; index as i; count as numElements">
        <ng-container *ngIf="i >= numElements / 2">
          <ng-container *ngTemplateOutlet="passwordRequirement; context: {$implicit: item}"></ng-container>
        </ng-container>
      </ng-container>
    </div>
  </div>

  <!-- Each password requirement line item-->
  <ng-template #passwordRequirement let-context>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
      <div class="requirement-prefix" *ngIf="!context.isRequirementSatisfied">&#x2022;</div>
      <mat-icon *ngIf="context.isRequirementSatisfied" class="check-icon requirement-prefix">done</mat-icon>

      <adp-label [labelKey]="context.contentKey" [class.password-requirement-satisfied-text]="context.isRequirementSatisfied"></adp-label>
    </div>
  </ng-template>

</form>
